/**
 * @import { HTMLElementInfo } from './core.js'
 */

function hideOptionsList(event) {
	const elem = event.currentTarget;
	if (elem && elem == document.activeElement) {
		// delay a bit or else it won't work
		setTimeout(() => elem.blur(), 200);
	}
}

/**
 * Gets an options button element.
 * When clicked, it shows a list of options.
 * @param {HTMLElementInfo} icon
 * @param {Array<HTMLElementInfo>} options
 * @returns {HTMLElementInfo}
 */
export function getOptionsButton(icon, options) {
	const list = {
		tag: "ul",
		class: "options-list",
		content: options
	};
	return {
		tag: "span",
		attri: { tabindex: "0" },
		class: "options-button",
		events: { "mousedown": hideOptionsList },
		content: [icon, list]
	};
}

/**
 * Creates a page header component with customizable options.
 * @param {boolean} putBackBtn - Whether to display a back button
 * @param {HTMLElementInfo} titleElem - The title element-info to display
 * @param {Array<HTMLElementInfo>} [leftOfMenuButton] - Content to display on the left side of the menu button
 * @param {Array<HTMLElementInfo>} [menuOptions] - Menu options, or no menu button displayed if not provided
 * @returns {HTMLElementInfo}
 */
export function getPageHeader(putBackBtn, titleElem, leftOfMenuButton, menuOptions) {
	const backBtn = putBackBtn && {
		tag: "i", class: "bi bi-arrow-left-circle",
		title: "Back", style: "margin-right: 14px",
		events: { "click": () => window.history.back() }
	};

	const rightContent = leftOfMenuButton ?? [];

	if (menuOptions) {
		const icon = { tag: "i", class: "bi bi-three-dots-vertical" };
		const menuBtn = getOptionsButton(icon, menuOptions);
		rightContent.push(menuBtn);
	}

	const rightSide = { tag: "div", style: "float: right", content: rightContent };

	const headerDiv = {
		tag: "div", class: "page-header",
		content: [backBtn, titleElem, rightSide]
	};
	return headerDiv;
}

/**
 * @param {HTMLElement} container Parent of the progress bar
 * @param {number} progress Between 0 and 100
 */
export function updateProgressBar(container, progress) {
	if (container) {
		const bar = container.getElementsByClassName("progress-bar-content")[0];
		const text = container.getElementsByClassName("progress-bar-text")[0];
		if (bar && text) {
			const barElem = /** @type {HTMLElement} */ (bar);
			barElem.style.width = progress + '%';
			text.textContent = progress + '%';
		}
	}
}
